import { useEffect, useState } from 'react';

/**
 * Latch a boolean ON after `delayMs` once the source flips to true.
 * Snaps back to false immediately when the source goes false again.
 *
 * Used by the winner-screen orchestrator to separate "block is on
 * screen" from "block's inner odometer can start" — the row fades
 * in showing zeroes, then a beat later the rolling-numbers kick off.
 */
export function useDelayedFlag(flag: boolean, delayMs: number): boolean {
  const [on, setOn] = useState(false);

  useEffect(() => {
    if (!flag) {
      setOn(false);
      return;
    }
    const t = window.setTimeout(() => setOn(true), delayMs);
    return () => window.clearTimeout(t);
  }, [flag, delayMs]);

  return on;
}
